/* BARRA DE CARGA.
   Arranca cuando el visitante hace click en un link interno y vive hasta que
   el navegador reemplaza la pagina. No hace falta saber cuanto falta: el truco
   —el mismo que usa Huel— es simular el avance con un tiron inicial y despues
   una meseta, asi la espera se percibe mas corta de lo que es. */
(function(){
  var barra=document.createElement('div');
  /* "no-empty" es del tema: Pillar esconde todo div vacio con
     div:empty:not(...,.no-empty){display:none}. La barra es un div vacio. */
  barra.className='rz-carga no-empty';
  barra.setAttribute('role','presentation');
  function montar(){ (document.body||document.documentElement).appendChild(barra); }
  if(document.body) montar();
  else document.addEventListener('DOMContentLoaded',montar);

  var t=null, pct=0, andando=false;

  function poner(p){ pct=p; barra.style.transform='scaleX('+(p/100)+')'; }

  function arrancar(){
    if(andando) return;
    andando=true;
    barra.classList.add('is-on');
    poner(0);
    /* el tiron: 0 -> 19% en un frame, que con la transicion de 180ms se ve
       como un golpe rapido */
    requestAnimationFrame(function(){ poner(19); });
    /* la meseta: se arrastra de a poco y NUNCA llega sola al final */
    t=setInterval(function(){
      if(pct<90) poner(pct + Math.max(0.4,(90-pct)/22));
    },220);
  }

  function terminar(){
    if(!andando) return;
    clearInterval(t);
    poner(100);
    setTimeout(function(){
      barra.classList.remove('is-on');
      setTimeout(function(){ poner(0); andando=false; },200);
    },180);
  }

  /* Cualquier click en un link interno que realmente vaya a navegar. */
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a[href]');
    if(!a) return;
    if(a.target==='_blank' || a.hasAttribute('download')) return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return;
    var href=a.getAttribute('href')||'';
    if(href.charAt(0)==='#' || href.indexOf('mailto:')===0 || href.indexOf('tel:')===0) return;
    if(a.origin && a.origin!==location.origin) return;
    /* el carrito abre el cajon, no navega */
    if(/\/cart($|\?)/.test(a.pathname||'')) return;
    if(a.pathname===location.pathname && a.search===location.search) return;
    arrancar();
  });

  /* Los formularios que llevan a otra pagina (buscador, checkout) tambien. */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(f && f.getAttribute && (f.getAttribute('action')||'').indexOf('/cart/add')===-1) arrancar();
  });

  /* RED DE SEGURIDAD: cualquier salida de la pagina, venga de donde venga
     —un submit, un redirect por JS, el boton de atras, una URL tipeada—
     dispara la barra igual. El click es el camino rapido; esto es el que no
     se escapa ninguna. */
  window.addEventListener('beforeunload',arrancar);

  /* Y LO MAS IMPORTANTE: la barra tambien corre mientras la pagina que estas
     abriendo TERMINA de cargar. Sin esto solo se veia al SALIR de una pagina,
     que es un parpadeo cuando la siguiente carga rapido. Con esto se ve al
     entrar a cada seccion, que es lo que se espera de una barra de carga. */
  if(document.readyState!=='complete'){
    arrancar();
    window.addEventListener('load',function(){ setTimeout(terminar,80); });
  }

  /* Si se vuelve con el boton de atras (bfcache), se limpia. */
  window.addEventListener('pageshow',terminar);
  window.addEventListener('pagehide',function(){ clearInterval(t); });
})();
